import { submissionConfig } from "app/constants/content";
import { secondsToDHms } from "app/hooks/useCountdown";

export const alertExamStatus = {
  missing: `⚠️ The exam has ended, but your answer hasn't been submitted yet. You can still submit within the extended time of ${secondsToDHms(submissionConfig.extendedTime)}, but a score deduction will apply.`,
  missing2: `🔔 Time's Up! The exam has ended, but your answers haven't been submitted yet. You still have ${secondsToDHms(submissionConfig.extendedTime)} to submit under the extended time, but a score deduction will apply.`,
  // New status alerts (April 4, 2025)
  open: '✍️ You can enroll in this exam. Click to proceed to the enrollment page.',
  close: '❌ Enrollment period for this exam has ended.',
  standby: '📅 You are enrolled for this upcoming exam. It will be available soon.',
  countdown: '⏰ Your exam is starting soon. Make sure you are prepared!'
}
